// File: src/common/enum/priorityEnum.ts

/**
 * Enum com os valores esperados pelo backend, todos em maiúsculo.
 */
export enum PriorityLevel {
    NONE = '',
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW',
}

/**
 * Versão em português, caso necessário.
 */
export enum PriorityLevelBr {
    NONE = '',
    HIGH = 'Alta',
    MEDIUM = 'Média',
    LOW = 'Baixa',
}

/**
 * Mapeia cada valor para o texto exibido na UI.
 */
export const PriorityLevelLabel: Record<PriorityLevel, string> = {
    [PriorityLevel.NONE]: '',
    [PriorityLevel.HIGH]: 'Alta',
    [PriorityLevel.MEDIUM]: 'Média',
    [PriorityLevel.LOW]: 'Baixa',
};

/**
 * Mapeia cada valor para uma cor padrão para uso na UI.
 */
export const PriorityLevelColor: Record<PriorityLevel, string> = {
    [PriorityLevel.NONE]: '#808080',     // cinza
    [PriorityLevel.HIGH]: '#B22222',    // vermelho escuro
    [PriorityLevel.MEDIUM]: '#FFA500',  // laranja
    [PriorityLevel.LOW]: '#228B22',     // verde
};
